// Centralised content + imagery references.

import heroCity from "@/assets/images/sable/hero.jpg";
import strategyService from "@/assets/images/sable/strategy-service.jpg";
import regulatoryService from "@/assets/images/sable/regulatory-service.jpg";
import digitalService from "@/assets/images/sable/digital-service.jpg";
import transactionsService from "@/assets/images/sable/transactions-service.jpg";
import sableReception from "@/assets/images/sable/sable-reception.jpg";
import sableOffice from "@/assets/images/sable/sable-office.jpg";
import contactLounge from "@/assets/images/sable/contact-lounge-wide.jpg";

export const IMAGES = {
  heroCity,
  strategyService,
  regulatoryService,
  digitalService,
  transactionsService,
  reception: sableReception,
  officeDark: sableOffice,
  conferenceTable: contactLounge,
};

export const SERVICES = [
  {
    key: "strategy",
    title: "Strategy",
    short: "Defining direction and creating value in complex and competitive markets.",
    long:
      "We help leadership teams clarify direction, sharpen positioning, and prioritise the decisions that compound over time — from market entry and growth strategy to operating model and capital allocation.",
    image: "strategyService",
    bullets: [
      "Corporate & growth strategy",
      "Market entry and expansion",
      "Operating model design",
      "Strategic positioning",
    ],
  },
  {
    key: "regulatory",
    title: "Regulatory",
    short: "Navigating regulatory landscapes and managing risk with confidence.",
    long:
      "We guide companies through evolving regulatory environments — anticipating change, engaging effectively with regulators, and building governance that protects value while enabling growth.",
    image: "regulatoryService",
    bullets: [
      "Regulatory strategy & engagement",
      "Compliance frameworks",
      "Policy & public affairs",
      "Risk and governance",
    ],
  },
  {
    key: "digital",
    title: "Digital",
    short: "Advising on digital business models, platforms, and product strategy.",
    long:
      "We work alongside founders and operators to shape digital propositions — from platform economics and product strategy to data, monetisation, and the operational foundations needed to scale.",
    image: "digitalService",
    bullets: [
      "Digital & platform strategy",
      "Product and proposition design",
      "Data and monetisation",
      "Technology operating models",
    ],
  },
  {
    key: "transactions",
    title: "Transactions",
    short:
      "Supporting critical transactions and providing thorough due diligence.",
    long:
      "We support investors and corporates through critical transactions — providing commercial due diligence, value creation planning, and trusted advice through negotiation, closing, and integration.",
    image: "transactionsService",
    bullets: [
      "Commercial due diligence",
      "Value creation planning",
      "M&A advisory support",
      "Post-transaction integration",
    ],
  },
];

export const INDUSTRIES = [
  { name: "Technology", description: "Software, infrastructure, and emerging tech." },
  {
    name: "Media & Entertainment",
    description: "Content, broadcast, and digital platforms.",
  },
  {
    name: "Digital Platforms",
    description: "Marketplaces, networks, and platform businesses.",
  },
  {
    name: "Investment & Private Equity",
    description: "Funds, family offices, and corporate investors.",
  },
];
